<div class="display-flex align-items-center">
  <fa-icon
    *ngIf="!isCopied && values && values.length > 0"
    icon="copy"
    (click)="clipboardCopy()"
    class="font-icon-color-darker cursor-pointer background-white margin-right-small">
  </fa-icon>
  <fa-icon
    *ngIf="isCopied"
    icon="check-circle"
    class="font-icon-color-notification-success-important background-white margin-right-small">
  </fa-icon>
</div>

